import { Divider, Stack } from '@mui/material';
import { NegotiationBoundariesForm, NegotiationBoundaryAdjustmentsForm } from '@procureai/ui-modules-mui';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { TsrctNegotiationMode, TsrctSupplierInteractionMode } from '@/generated/gql/graphql';
import { NegotiationOptionsLegacyForm } from '~/components/NegotiationTermsForm/components/NegotiationOptionsLegacyForm/NegotiationOptionsLegacyForm.tsx';

import { TermsFormData } from './NegotiationTermsForm.schema';

export const NegotiationTermsForm = () => {
  const { watch, setValue } = useFormContext<TermsFormData>();

  const negotiationMode = watch('options.negotiationMode');

  // TODO remove as soon as final-offer is supported backend-wise for line-item negotiation
  useEffect(() => {
    if (negotiationMode === TsrctNegotiationMode.LINE_ITEM) {
      setValue('options.supplierInteractionMode', TsrctSupplierInteractionMode.COMMENT_ENABLED);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [negotiationMode]);

  return (
    <Stack direction="column" spacing={3}>
      <NegotiationBoundariesForm />
      <NegotiationBoundaryAdjustmentsForm />
      <Divider />
      <NegotiationOptionsLegacyForm />
    </Stack>
  );
};
